import secureLocalStorage from "react-secure-storage";
import { stdObject } from "../../../data/types/stdObject";
import { sendData } from "../../../services/sendData";
import { enterLogin } from "./enterLogin";

// Called when the user picks a branch from the login-time selectBranchModal
// (only shown when their v_usu.MULUSU = 1 and more than one v_suc row has
// ACTSUC = 1 - see login.php's multiBranch/branches fields). Reuses the
// same call_branch.php endpoint and secureLocalStorage["branch"] mechanism
// as the existing in-app branch switcher (switchBranch in useMainFrame.ts),
// so getBranchInfo() picks the choice up on the very first bootstrap pass
// without needing a reload here.
export const selectLoginBranch = async (params: stdObject) => {
  const { code, dispatch, closeMsg, loginPack, logoutAction } = params;

  const response: stdObject = await sendData({
    endPoint: "callBranch",
    payload: { code },
    logoutAction,
  });

  if (response.success && response.status) {
    secureLocalStorage.setItem("branch", JSON.stringify(response.data));
    // Marks this session as "chosen at login" so clearSessionOnExit
    // (handlePage.ts) forces a fresh login - and a fresh branch pick - on
    // the next close/reload instead of silently resuming.
    secureLocalStorage.setItem("branchSelectedAtLogin", "1");
    closeMsg();
    enterLogin({ dispatch, callback: closeMsg, loginPack });
  }
};
